import Axios from '@/utils/axios'

const URL = '/entregas-epi'

export default {
  listar: () => Axios.get(URL),
  confirmar: (ids, assinaturaUrl) => Axios.post(`${URL}/confirmar`, { ids, assinaturaUrl }),
  downloadComprovante: id => Axios.get(`${URL}/${id}/comprovante`)
}
